import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBars, 
  faGauge, // Replaced faDashboard with faGauge
  faClipboardCheck,
  faChartBar, 
  faMoneyCheckAlt, 
  faUserCircle 
} from '@fortawesome/free-solid-svg-icons';
import { useSidebar } from './SidebarContext';

const StudentSidebar = () => {
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  const menuItems = [
    { id: 'dashboard', name: 'Dashboard', icon: faGauge, path: '/studentmark-dashboard' },
    { id: 'Quiz', name: 'Test', icon: faClipboardCheck, path: '/generate-test' },
    { id: 'results', name: 'Results', icon: faChartBar, path: '/Result' },
    { id: 'payment', name: 'Payment', icon: faMoneyCheckAlt, path: '/Payment-student' },
    { id: 'profile', name: 'My Account', icon: faUserCircle, path: '/profile' }
  ];

  const handleMenuItemClick = (item) => {
    setActiveMenuItem(item.id);
    if (item.path) {
      navigate(item.path);
    }
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = menuItems.find(item => item.path === currentPath);
    if (matchedItem) {
      setActiveMenuItem(matchedItem.id);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar-wrapper">
      {/* Toggle Button */}
      
      {/* Sidebar */}
      <div
        className="sidebar"
        style={{
          width: isSidebarOpen ? '250px' : '70px',
        }}
      >
        <div className="logo-section">
          <img
            src={isSidebarOpen ? '../images/full-logo.jpeg' : '../images/logo.jpeg'}
            alt="Logo"
            style={{
              height: '32px',
              transition: 'all 0.3s ease',
              objectFit: 'contain'
            }}
          />
        </div>

        <div className="menu-section">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className={`sidebar-menu-item ${activeMenuItem === item.id ? 'active' : ''}`}
              onClick={() => handleMenuItemClick(item)}
            >
              <div className="menu-item-content">
                <FontAwesomeIcon icon={item.icon} />
                {isSidebarOpen && <span>{item.name}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .sidebar-wrapper {
          position: relative;
        }

        .sidebar {
          height: 100vh;
          background: linear-gradient(to right, #F3E8FF, #FEE7EF);
          color: gray;
          position: fixed;
          top: 0;
          left: 0;
          overflow-x: hidden;
          overflow-y: auto;
          transition: width 0.2s ease-in-out;
          z-index: 1000;
        }

        .logo-section {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 60px;
          overflow: hidden;
        }

        .menu-section {
          padding: 16px;
        }

        .sidebar-menu-item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 16px;
          border-radius: 30px;
          margin-bottom: 5px;
          cursor: pointer;
          transition: all 0.2s ease;
          color: black;
        }

        .sidebar-menu-item:hover {
          color: #6B21A8;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
        }

        .sidebar-menu-item.active {
          background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.6));
          color: #6B21A8;
        }

        .menu-item-content {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .sidebar-toggle {
          position: fixed;
          top: 16px;
          height: 40px;
          width: 40px;
          background: #ffffff;
          border: none;
          border-radius: 30px;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          cursor: pointer;
          z-index: 1100;
          transition: left 0.2s ease-in-out;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        @media (max-width: 768px) {
          .sidebar {
            width: 70px !important;
          }

          .sidebar-toggle {
            left: 70px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default StudentSidebar;